import React, { useEffect, useRef } from "react"
import styled from "styled-components"

const Glow = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 460px;
  height: 460px;
  margin: -230px 0 0 -230px;
  border-radius: 50%;
  pointer-events: none;
  z-index: 95;
  mix-blend-mode: screen;
  opacity: 0;
  transition: opacity 0.6s ease;
  will-change: transform, opacity;
  background: radial-gradient(
    circle,
    rgba(231, 163, 56, 0.16),
    rgba(231, 163, 56, 0.05) 40%,
    rgba(231, 163, 56, 0) 65%
  );
`

const CursorGlow = () => {
  const ref = useRef(null)

  useEffect(() => {
    const el = ref.current
    if (!el || !window.matchMedia) return

    // mouse devices only; respect reduced motion
    const finePointer = window.matchMedia(
      "(hover: hover) and (pointer: fine)"
    ).matches
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    if (!finePointer || reduce) return

    let tx = window.innerWidth / 2
    let ty = window.innerHeight / 2
    let x = tx
    let y = ty
    let raf = null
    let shown = false

    const onMove = (e) => {
      tx = e.clientX
      ty = e.clientY
      if (!shown) {
        shown = true
        el.style.opacity = "1"
      }
    }
    const onLeave = () => {
      shown = false
      el.style.opacity = "0"
    }

    const loop = () => {
      x += (tx - x) * 0.14
      y += (ty - y) * 0.14
      el.style.transform = `translate(${x}px, ${y}px)`
      raf = window.requestAnimationFrame(loop)
    }

    window.addEventListener("pointermove", onMove, { passive: true })
    document.addEventListener("mouseleave", onLeave)
    loop()

    return () => {
      window.removeEventListener("pointermove", onMove)
      document.removeEventListener("mouseleave", onLeave)
      if (raf) window.cancelAnimationFrame(raf)
    }
  }, [])

  return <Glow ref={ref} aria-hidden="true" />
}

export default CursorGlow
